import React, { useContext } from 'react';
import Moment from 'react-moment';
import SaveContext from '../../context/SaveContext';
import DialogNotification from '../DialogNotification/DialogNotification';

/** Mostra caixa de dialogo com uma notificação de erro no servidor   */
const DialogNotificationServerError = ({ saveContext }) => (
  <DialogNotification
    okAction={() => saveContext.setSavingStatus({
      ...saveContext.savingStatus,
      isSuccessfulSave: true,
    })}
    title={<span className="color-danger">Erro no servidor</span>}
    content={(
      <>
        <p>
          Não foi possível salvar a última alteração no fluxo,
          por que aconteceu algum erro inesperado no servidor.
          <br />
          Recarregamos a última versão salva para você continuar o trabalho.
          <br />
          Se o erro voltar a acontecer entre em contato com o suporte do Serprobots.
        </p>
      </>
          )}
  />
);

/**
 * Painel do status de salvamento
 */
export function SavingStatusPanel() {
  const saveContext = useContext(SaveContext);
  if (!saveContext.savingStatus.isSuccessfulSave) {
    return <DialogNotificationServerError saveContext={saveContext} />;
  }
  if (!saveContext.savingStatus.lastSaveTime && !saveContext.savingStatus.isSaving) return <></>;
  return (
    <>
      <li className="divider">
        <div className="savestatus">
          {saveContext.savingStatus.isSaving ? <p><small>Salvando...</small></p> : (
            <p>
              <small>
                {saveContext.savingStatus.lastSaveTime ? (
                  <>
                    {'Salvo em '}
                    <Moment format="HH:mm">{saveContext.savingStatus.lastSaveTime}</Moment>
                  </>
                ) : null}
              </small>
            </p>
          )}
        </div>
      </li>
    </>
  );
}

export default SavingStatusPanel;
